'use strict';

window.site = window.site || {};

/**
 * Init Mobile Menu related scripts
 * @class Site
 * @static
 */
site.Career001 = function Career001() {

  'use strict';

  /**
   * jQuery elements
   * @private
   */

  /**
   * Has the class been initialized?
   * @private
   */

  var inited = false;

  /**
   * Initializes the class.
   * @public
   */
  var init = function init() {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    var $slider = document.querySelector('.career001 .career001-list');

    if ($slider) {
      var flkty = new Flickity($slider, {
        // options
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        imagesLoaded: true,
        watchCSS: true
      });
    }

    return true;
  };

  // Expose public methods & properties
  return {
    init: init
  };
}();